<template>
  <div>
    <left-sidebar :ppa="ppa" />
    <right-sidebar :ppa="ppa" />
    <header-bp
      :user="user"
      :ppa="ppa"
    />
    <div class="header-spacer" />
    <div class="container">
      <div class="row">
        Hello Familial
      </div>
    </div>
    <a
      href="#"
      class="back-to-top"
    >
      <app-icon
        name="olymp-stats-arrow-icon"
        tooltip="Back to top"
        color="white"
        size="medium"
      />
    </a>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import LeftSidebar from '../../components/common-apps/common/LeftSidebar'
import RightSidebar from '../../components/common-apps/common/RightSidebar'
import HeaderBp from '../../components/common-apps/common/HeaderBp'
import AppIcon from "../../components/common-apps/common/AppIcon";
// import {format} from "date-fns";

export default {
  name: 'List',
  components: {
    LeftSidebar,
    RightSidebar,
    HeaderBp,
    AppIcon,
  },
  data () {
    return {
    }
  },
  computed: mapState({
    ppa: state => state.account.ppa,
    user () {
      return !this.$store.getters['account/user'] ? { username: 'None' } : this.$store.getters['account/user']
    }
  }),
  mounted() {
    document.body.classList.add('month-page')
  },
  destroyed () {
    document.body.classList.remove('month-page')
  },
  created () {
    this.$store.dispatch('account/fetchUser')
    // if (!this.$store.hasModule('ticket')) {
    //   this.$store.registerModule('ticket', ticketStore)
    // }
  },
  // beforeDestroy () {
  //   this.$store.unregisterModule('ticket')
  // },
  methods: {

  }
}
</script>

<style lang="scss">
// Bootstrap from node_modules has container smaller
@import '../../scss/Bootstrap/scss/bootstrap-reboot';
@import '../../scss/Bootstrap/scss/bootstrap';
@import '../../scss/Bootstrap/scss/bootstrap-grid';

@import '../../scss/ticket2';
// @import '../../scss/fonts';

/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 18px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}

</style>
